export default __webpack_public_path__ + "static/flag-light-mode-59b955e669137b52c936b4abb188d4a3.png";